var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default function Radio(_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    return (_jsxs(Container, { checked: value, onClick: onChange, children: [_jsx("button", { children: _jsx("div", {}) }), _jsx("p", { children: label })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  gap: 16px;\n  justify-content: flex-start;\n  opacity: ", ";\n  padding: 0 16px 0 24px;\n  width: 100%;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  & > button {\n    border: ", ";\n    border-radius: 50%;\n    height: 24px;\n    padding: 4px;\n    width: 24px;\n\n    & > div {\n      background-color: ", ";\n      border-radius: 50%;\n      height: 100%;\n      opacity: ", ";\n      transition: opacity 200ms ease-in-out;\n      width: 100%;\n    }\n  }\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400;\n    color: ", ";\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  gap: 16px;\n  justify-content: flex-start;\n  opacity: ", ";\n  padding: 0 16px 0 24px;\n  width: 100%;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  & > button {\n    border: ", ";\n    border-radius: 50%;\n    height: 24px;\n    padding: 4px;\n    width: 24px;\n\n    & > div {\n      background-color: ", ";\n      border-radius: 50%;\n      height: 100%;\n      opacity: ", ";\n      transition: opacity 200ms ease-in-out;\n      width: 100%;\n    }\n  }\n\n  & > p {\n    font-size: 16px;\n    font-weight: 400;\n    color: ", ";\n  }\n"])), function (_a) {
    var checked = _a.checked;
    return (checked ? '1' : '0.7');
}, function (_a) {
    var checked = _a.checked;
    return (checked ? '0.8' : '0.5');
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked ? "solid 1px ".concat(theme.palette.gold) : "solid 1px ".concat(theme.palette.text);
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.gold;
}, function (_a) {
    var checked = _a.checked;
    return (checked ? '1' : '0');
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return (checked ? theme.palette.gold : theme.palette.text);
});
var templateObject_1;
